module.exports = __webpack_public_path__ + "media/images/icons/academic-development_05-122b7dcd9178f807922030bc46e40841.svg";